import { render, staticRenderFns } from "./BaseWidgetTitle.vue?vue&type=template&id=6e3a1993&scoped=true"
import script from "./BaseWidgetTitle.vue?vue&type=script&lang=js"
export * from "./BaseWidgetTitle.vue?vue&type=script&lang=js"
import style0 from "./BaseWidgetTitle.vue?vue&type=style&index=0&id=6e3a1993&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3a1993",
  null
  
)

export default component.exports